import { render } from "./AdminView.vue?vue&type=template&id=b85e142c&scoped=true"
const script = {}

import "./AdminView.vue?vue&type=style&index=0&id=b85e142c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85e142c"]])

export default __exports__